import { Component, inject,effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HuntContextService } from '../../../../../services/hunt-context.service';

import { MarkdownComponent, TypographyComponent } from '@hyperkit';
@Component({
  selector: 'query-selected-deployment-requirements-tab',
  imports: [CommonModule, TypographyComponent, MarkdownComponent],
  templateUrl: './deployment-requirements-tab.component.html',
  styleUrl: './deployment-requirements-tab.component.scss',
})
export class DeploymentRequirementsTabComponent {
  readonly hunt = inject(HuntContextService); // inject full context if you're already using it
  readonly packageContent = this.hunt.queryPackages.content;
  readonly selectedQuery = this.hunt.queryLogic.selectedQuery;

  constructor(){
    console.log('package contents', this.packageContent())
  }
}
